import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { AuthService } from '../../../AuthService';

@Injectable({
  providedIn: 'root'
})
export class RestApiService {
private httpOptions:any
  constructor(private _http:HttpClient,private authservice: AuthService) {
    this.authservice.getKeyCloackToken("");
    this.authservice.getKeyCloackUserInfo("");
   }
private sethttpHeaderWithtoken(){
this.httpOptions =  new HttpHeaders({
  'Accept':'application/json',
  'Content-Type':'application/json',
});
}

public getAPI(url:string,param?:any){
  // if(param)this.httpOptions.param=param;
   return lastValueFrom(
    this._http.get<any>(url,param)
   );
}

public postAPI(url:string,requestBody:any){
  return lastValueFrom(
    this._http.post<any>(url,requestBody,this.httpOptions)
   );
}
public patchAPI(url:string,requestBody:any){
  return lastValueFrom(
    this._http.patch<any>(url,requestBody,this.httpOptions)
   );
}
public deleteAPI(url:string,requestBody:any){
  return lastValueFrom(
    this._http.delete<any>(url,this.httpOptions)
   );
}
public postAPIDownlaod(url:string,requestBody:any) {

  return lastValueFrom(

    this._http.post<Blob>(url,requestBody, {responseType: 'blob' as 'json'})

  );
}

public getAPIDownlaod(url:string,requestBody:any) {
  return lastValueFrom(
    this._http.get<Blob>(url,{params:requestBody,responseType:'blob' as 'json'})
  );
}

}
